import { render, staticRenderFns } from "./Level.vue?vue&type=template&id=6cb83388&scoped=true&"
import script from "./Level.vue?vue&type=script&lang=js&"
export * from "./Level.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb83388",
  null
  
)

export default component.exports